<template v-cloak>
    <NuxtLayout name="main" dark class="bg-[#F7F6FB]">
        <div class="mx-auto my-[56px] px-[64px] py-[62px] w-[1264px] bg-white">
            <div class="text-[44px] leading-[62px] font-bold text-emphas">{{ $t("DataSimplification") }}</div>
            <div class="w-[132px] h-[4px] bg-main mt-[22px] mb-[46px]"></div>
            <div
                class="mb-[40px] pl-[80px] h-[240px] flex flex-col justify-center bg-[url(https://rdgta.cdn.cyagen.com/rddc/pictures/d701dfbe-fc23-4071-b431-5b18c1f49457.webp)] font-bold text-white">
                <div v-if="$i18n.locale == 'en'" class="text-[30px] leading-[42px]">
                    <p>{{ $t("DataSimplificationI18n.Name1") }}</p>
                    <p>{{ $t("DataSimplificationI18n.Name2") }}</p>
                    <p>Field of Rare Diseases</p>
                </div>
                <div v-else>
                    <p class="text-[30px] leading-[46px]">{{ $t("DataSimplificationI18n.Name1") }}</p>
                    <p class="mt-[4px] text-[40px] leading-[56px]">{{ $t("DataSimplificationI18n.Name2") }}</p>
                </div>
            </div>
            <p class="text-[16px]">{{ $t("DataSimplificationI18n.Descript1") }}</p>
            <p class="text-[16px] mt-[24px]">{{ $t("DataSimplificationI18n.Descript2") }}</p>
            <p class="text-[16px] mt-[24px]">{{ $t("DataSimplificationI18n.Descript3") }}</p>
        </div>
    </NuxtLayout>
</template>
